<template>
  <button
    class="hamburger"
    :class="{'hamburger--active': isActive}"
    type="button"
    @click="handleClick">
    <span class="hamburger__inner" />
  </button>
</template>

<script>
export default {
  name: 'BaseBurger',

  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    handleClick() {
      this.$emit('click', !this.isActive);
    },
  },
};
</script>

<style lang="scss" scoped>
  .hamburger {
    width: 24px;
    height: 24px;
    position: relative;
    cursor: pointer;
    background: none;
    border: 0;
    outline: none;
  }

  .hamburger__inner:before,
  .hamburger__inner:after {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    height: 3px;
    border-radius: 1px;
    background-color: $color--basic-white;
    transition: transform .2s ease-out;
  }

  .hamburger__inner:before {
    transform:  translateY(-200%);
  }

  .hamburger__inner:after {
    transform:  translateY(100%);
  }

  .hamburger--active {
    .hamburger__inner:before {
      transform: translateY(-50%) rotate(45deg);
    }

    .hamburger__inner:after {
      transform: translateY(-50%) rotate(-45deg);
    }
  }
</style>
